import { convertEventHandlingToDB, convertLocationToDB, convertMonitorStatusToDB, convertMonitorTypeToDB } from "../common/utils";
import { APIClient } from "../helpers/api_helper";
import { GET_CONNECTION_LOG_BY_DEVICE_ID, GET_DEVELOPER_ALL_COMPANY, GET_DEVELOPER_DEVICES, GET_DEVELOPER_EVENT_BY_COMPANY_ID, GET_DEVELOPER_FLOORPLAN_BY_COMPANY_ID, GET_DEVICE_CONFIG, GET_DEVICE_ID_BY_COMPANY_ID, GET_VERSION, UPDATE_PASSWORD } from "../helpers/url_helper";

const api = new APIClient();

export const getDevicesByDeveloper = async () => {
    return await api.get(GET_DEVELOPER_DEVICES);
};

export const getDeviceConfig = async (deviceID) => {
    let result = await api.get(GET_DEVICE_CONFIG + "/" + deviceID);
    console.log("getDeviceConfig");
    console.log(result);
    return result;
};

export const getAPIVersion = async (deviceID) => {
    let result = await api.get(GET_VERSION);
    console.log("getAPIVersion");
    console.log(result);
    return result;
};

export const resetPassword = async (username, oldPassword, newPassword) => {
    return await api.create(UPDATE_PASSWORD, { username: username, password: newPassword, oldPassword: oldPassword });
}

export const getAllCompaniesService = async () => {
    return await api.get(GET_DEVELOPER_ALL_COMPANY);
};

export const getFloorPlanByCompanyIDService = async (companyID) => {
    return await api.get(GET_DEVELOPER_FLOORPLAN_BY_COMPANY_ID + `/${companyID}`);
};

export const getEventReportByCompanyIDService = async (selectedCompanyID, selectedFloorPlan, selectedType, selectedStatus, selectedEventHandling, dateRange, pageNumber, pageSize) => {
    let data2 = dateRange[1];
    if (isNaN(data2)) {
        data2 = dateRange[0];
    }
    let startDt = new Date(dateRange[0] > data2 ? data2 : dateRange[0]);
    startDt.setHours(0);
    startDt.setMinutes(0);
    startDt.setSeconds(0);
    let endDt = new Date(dateRange[0] > data2 ? dateRange[0] : data2);
    endDt.setDate(endDt.getDate());
    endDt.setHours(23);
    endDt.setMinutes(59);
    endDt.setSeconds(59);
    const query = {
        page: pageNumber,
        pageSize: pageSize,
        location: JSON.stringify(convertLocationToDB(selectedFloorPlan)),
        type: JSON.stringify(convertMonitorTypeToDB(selectedType)),
        status: JSON.stringify(convertMonitorStatusToDB(selectedStatus)),
        eventHandling: JSON.stringify(convertEventHandlingToDB(selectedEventHandling)),
        startDt: Math.trunc(startDt.getTime() / 1000),
        endDt: Math.trunc(endDt.getTime() / 1000)
    };
    console.log(query);
    return await api.get(GET_DEVELOPER_EVENT_BY_COMPANY_ID + `/${selectedCompanyID}`, query);
};


export const getEventReportByDeviceIDService = async (selectedDeviceID, dateRange, pageNumber, pageSize) => {
    let data2 = dateRange[1];
    if (isNaN(data2)) {
        data2 = dateRange[0];
    }
    let startDt = new Date(dateRange[0] > data2 ? data2 : dateRange[0]);
    startDt.setHours(0);
    startDt.setMinutes(0);
    startDt.setSeconds(0);
    let endDt = new Date(dateRange[0] > data2 ? dateRange[0] : data2);
    endDt.setDate(endDt.getDate());
    endDt.setHours(23);
    endDt.setMinutes(59);
    endDt.setSeconds(59);
    const query = {
        page: pageNumber,
        pageSize: pageSize,
        startDt: Math.trunc(startDt.getTime() / 1000),
        endDt: Math.trunc(endDt.getTime() / 1000)
    };
    console.log(query);
    return await api.get(GET_CONNECTION_LOG_BY_DEVICE_ID + `/${selectedDeviceID}`, query);
};

export const getDeviceIDnByCompanyIDService = async (companyID) => {
    return await api.get(GET_DEVICE_ID_BY_COMPANY_ID + `/${companyID}`);
};
